import products from './products'
import profile from './profile'
import perfil from './perfil'

export default {
  products,
  profile,
  perfil
}
